import React from "react";
import "./CSS/style.css";
import "./CSS/media.css";

function Contact() {
  return (
    <div className="contact container-fluid">
      <div className="container">
        <div className="row">
          <div className="col-md-12 contact__title">
            <p>04. What's Next?</p>
            <h1>Get In Touch</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6 contact__detail">
            <p>
              Although I'm not currently looking for any new opportunities, my
              inbox is always open. Whether you have a question or just want to
              say hi, I'll try my best to get back to you!
            </p>
          </div>
          <div className="col-md-3"></div>
        </div>
        <div className="row">
          <div className="col-md-12 contact__button">
            <a href="mailto:khansaud150@gmail.com">Say Hello</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
